import api, { apiPrefix } from './Api';
import { Brand, brandFromResponse } from '../interfaces/Brand/Brand';
import { Meta, metaFromResponse } from '../interfaces/Meta/Meta';

const brandApiPrefix = `${apiPrefix}/brands`;

export const getBrands = async (): Promise<Brand[]> => {
  const response = await api.get(brandApiPrefix);

  return (response.data?.data ?? []).map((brand: any) =>
    brandFromResponse(brand),
  );
};

export const getBrandMeta = async (slug: string): Promise<Meta> => {
  const response = await api.get(`${brandApiPrefix}/meta/${slug}`);

  return metaFromResponse(response.data?.data);
};
